import { createContext } from "react";

import { IRemoteDataContext, IBank } from "../interfaces-and-types";

// interface IBankListByCountry {
//   country: string;
//   banksList: IBank[];
// }

export interface IRefreshBanksListByCountry
  extends IRemoteDataContext<IBank[] /*IBankListByCountry*/ | null> {
  refreshRemoteData: (country: string) => void;
}

export const BanksListContext = createContext<IRefreshBanksListByCountry>({
  // remote data
  isSuccess: false,
  isError: false,
  isLoading: false,
  data: null,
  refreshRemoteData: () => {},
});
